import { ChangeDetectorRef, Directive, DoCheck, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ProductAddToBasketComponentDef } from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { Customer } from '@df/session/api/customer';
import { ProductDecorator } from '../../model/product/product.decorator';

export class ProductStatusContext<T, C> {
    constructor(
        public $implicit: T,
        public status: C
    ) {}
}

@Directive({
    selector: 'ng-template[productStatus]',
    standalone: true
})
export class ProductStatusDirective extends ProductAddToBasketComponentDef implements DoCheck {
    @Input() set productStatus(product: ProductDecorator<IProductDataV2> | number) {
        if (typeof product === 'number') {
            this.productId = product;
        } else {
            this.product = product;
        }
    }

    constructor(
        private templateRef: TemplateRef<ProductStatusContext<Product, ProductAddToBasketComponentDef>>,
        private viewContainer: ViewContainerRef,
        customer: Customer,
        changeDetectorRef: ChangeDetectorRef
    ) {
        super(customer, changeDetectorRef);
    }

    /**
     * Applies the changes when needed.
     */
    ngDoCheck(): void {
        if (this.product) {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(
                this.templateRef,
                new ProductStatusContext<Product, ProductAddToBasketComponentDef>(this.product, this) // context
            );
        }
    }

    get isLowQty(): boolean {
        return this.isSalable && this.maxQty < 10 && this.maxQty > 0;
    }
}
